import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8536 18.8536C12.9473 18.7598 13 18.6326 13 18.5V6H17.5C17.6326 6 17.7598 5.94732 17.8536 5.85355C17.9473 5.75979 18 5.63261 18 5.5V4.5C18 4.36739 17.9473 4.24021 17.8536 4.14645C17.7598 4.05268 17.6326 4 17.5 4H6.5C6.36739 4 6.24021 4.05268 6.14645 4.14645C6.05268 4.24021 6 4.36739 6 4.5V5.5C6 5.63261 6.05268 5.75979 6.14645 5.85355C6.24021 5.94732 6.36739 6 6.5 6H11V18.5C11 18.6326 11.0527 18.7598 11.1464 18.8536C11.2402 18.9473 11.3674 19 11.5 19H12.5C12.6326 19 12.7598 18.9473 12.8536 18.8536Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgTextOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgTextOutline;
